// extracted by css-extract-rspack-plugin
export default {"reactionToggleButton":"ReactionButton-module__reactionToggleButton__hyALB","reactionToggleButtonReacted":"ReactionButton-module__reactionToggleButtonReacted__ITkNY"};